module.exports = __webpack_public_path__ + "static/fonts/SanFranciscoDisplayBold.b6fac09.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/SanFranciscoDisplayBold.woff
// module id = AGfS
// module chunks = 1